import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";

/**
 * Web service used to get match detail.
 */
@Injectable({
  providedIn: "root",
})
export class DismissMarketingMessageWS {
  constructor(private handler: BaseHandler) {}
  execute(
    token: string,
    id: string,
    type: "personal" | "marketing"
  ): Observable<void> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.DISMISS_MARKETING_MESSAGE_ENDPOINT())
      .setMethod(HttpMethod.post)
      .setBody({ id, type })
      .setAuthorization(new TokenAuthorization(token))
      .build();

    return this.handler.execute(parameters);
  }
}
